"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
let globalAxiosClient = null;
const timeout = typeof window === 'undefined' ? 3000 : 10000;
function axiosClient() {
    // Create a new client for every server-side request so that data
    // isn't shared between connections
    if (typeof window === 'undefined') {
        return createAxiosClient();
    }
    // Reuse client on the client-side
    if (!globalAxiosClient) {
        globalAxiosClient = createAxiosClient();
    }
    return globalAxiosClient;
}
function createAxiosClient() {
    const options = { timeout };
    const instance = axios_1.default.create(options);
    // Delete interceptors for SSR performance
    // @ts-ignore
    delete instance.interceptors;
    return instance;
}
exports.default = axiosClient;
//# sourceMappingURL=axiosClient.js.map